<button *ngIf="availableDashboards.length -1" mat-fab color="primary" class="dashboard-fab"
  [matMenuTriggerFor]="dashboardMenu" matTooltip="Change Dashboard">
  <mat-icon>dashboard</mat-icon>
</button>


<!-- <mat-menu #dashboardMenu="matMenu">
  <ng-container *ngFor="let dashboard of availableDashboards">
    <button mat-menu-item *ngIf="!isCurrentDashboard(dashboard.path)" (click)="switchToOtherDashboard(dashboard)">
      <span>{{ dashboard.label }}</span>
    </button>
  </ng-container>
</mat-menu> -->


<mat-menu #dashboardMenu="matMenu">
  <ng-container *ngFor="let dashboard of availableDashboards">
    <button mat-menu-item *ngIf="!isCurrentDashboard(dashboard.path)" (click)="switchToOtherDashboard(dashboard)">
      <span>{{ dashboard.label }}</span>
    </button>
  </ng-container>
</mat-menu>